import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { getAdminDashboard } from "../../api/flightApi";
import swal from "sweetalert";
import history from "../../history";
import { SimpleStatusLegend } from "./AdminStatusLegend";
import "../../styles/admin-manage.scss";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            users: "",
            bookings: "",
            transactions: "",
        };
    }

    componentDidMount() {
        this.fetchAdminDetails();
    }

    fetchAdminDetails() {
        getAdminDashboard()
            .then((response) => {
                this.setState({
                    users: response.data.users_count,
                    bookings: response.data.bookings_count,
                    transactions: response.data.transactions_count,
                    packages: response.data.packages_count,
                    partners: response.data.vendors_count ?? response.data.partners_count,
                    inquiries: response.data.inquiries_count,
                    categories: response.data.categories_count,
                    packageBooking: response.data.package_booking_count,
                    faq: response.data.faq_count,
                    cars: response.data.car_count,
                    carBooking: response.data.car_booking_count,
                    rentalPartner: response.data.rental_partner_count,
                    location: response.data.location_count,
                    carInquiry: response.data.car_inquiry_count,
                    vehicleType: response.data.vehicle_type_count,
                    vehicleRates: response.data.vehicle_rate_count,
                    routeRates: response.data.route_rate_count,
                    service_transaction:
                        response.data.service_transaction_count,
                    summary: response.data.summary_count,
                    addon: response.data.addon_count,
                    group_tours_count: response.data.group_tours_count || 0,
                    group_tourism_interests_count: response.data.group_tourism_interests_count || 0,
                    shared_rentals_count: response.data.shared_rentals_count || 0,
                    shared_rental_interests_count: response.data.shared_rental_interests_count || 0,
                });
            })
            .catch((error) => {
                // console.log(error);
                console.log("Dashboard fetch error", error);
            });
    }

    render() {
        const {
            users,
            bookings,
            transactions,
            packages,
            partners,
            inquiries,
            categories,
            packageBooking,
            faq,
            cars,
            carBooking,
            rentalPartner,
            location,
            carInquiry,
            vehicleType,
            vehicleRates,
            routeRates,
            service_transaction,
            summary,
            addon,
            group_tours_count = 0,
            group_tourism_interests_count = 0,
            shared_rentals_count = 0,
            shared_rental_interests_count = 0,
        } = this.state;

        const section = this.props.location.hash;

        const sectionTitle = (title) => (
            <div key={`title-${title}`} className="col-12 dashboard-section-title">
                <h5 className="mb-2 mt-3">{title}</h5>
            </div>
        );
        const subsectionTitle = (title) => (
            <div key={`sub-${title}`} className="col-12 dashboard-subsection-title">
                <h6>{title}</h6>
            </div>
        );

        return (
            <React.Fragment>
                <div className="dashboard container">
                    <div className="row">
                        {section === "" && (
                            <>
                                {sectionTitle("Content")}
                                <div className="widget col-12 col-md-6">
                                    <div className="card border-primary">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count" style={{ fontSize: '1.25rem' }}>CMS</span>
                                                <hr />
                                                <p className="mb-2 text-muted" style={{ fontSize: '0.9rem' }}>
                                                    Journeys, destinations, festivals, guides, media &amp; official sources
                                                </p>
                                                <Link to="/admin/cms" className="action">Open Content Management →</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* Vendors — at top */}
                        {(section === "" || section === "#vendors") && (
                            <>
                                {section === "" && sectionTitle("Vendors")}
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{partners}</span>
                                                <hr />
                                                <Link to="/admin/partners" className="action">All Vendors</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">+</span>
                                                <hr />
                                                <Link to="/admin/users_list" className="action">Convert user to vendor</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{summary}</span>
                                                <hr />
                                                <Link to="/admin/summaries" className="action">Vendor Payouts</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* Bookings — calendar + status guide */}
                        {(section === "" || section === "#packages") && section === "" && (
                            <>
                                {sectionTitle("Bookings")}
                                <div className="widget col-12 col-md-4">
                                    <div className="card">
                                        <div className="card-body text-center">
                                            <span className="count" style={{ fontSize: '1.1rem' }}>📅</span>
                                            <hr />
                                            <Link to="/admin/booking_calendar" className="action">Booking Calendar</Link>
                                            <p className="text-muted small mb-0 mt-2">Year view — group &amp; private by month</p>
                                            <Link to="/admin/flight_bookings" className="action d-block mt-2">Domestic flight bookings</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-12 col-md-8">
                                    <div className="card">
                                        <div className="card-body">
                                            <h6 className="mb-3">Status guide</h6>
                                            <SimpleStatusLegend title="Every booking is one of three statuses" />
                                            <p className="text-muted small mb-0 mt-2">
                                                Manage lists:{' '}
                                                <Link to="/admin/manage_group_trips">Group trips</Link>
                                                {' · '}
                                                <Link to="/admin/manage_shared_rentals">Shared rentals</Link>
                                                {' · '}
                                                <Link to="/admin/manage_private_tours">Private tours</Link>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* Manage — one heading, 3 cards (Group Trips, Shared Rentals, Private Tours) */}
                        {(section === "" || section === "#packages") && (
                            <>
                                {section === "" && sectionTitle("Manage")}
                                {section === "#packages" && subsectionTitle("Manage")}
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{group_tours_count}</span>
                                                <hr />
                                                <Link to="/admin/group_tours" className="action">View all Group Tours</Link>
                                                <br />
                                                <Link to="/admin/manage_group_trips" className="action">Manage Group Trips</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{shared_rentals_count}</span>
                                                <hr />
                                                <Link to="/admin/shared_rentals" className="action">View all Shared Rentals</Link>
                                                <br />
                                                <Link to="/admin/manage_shared_rentals" className="action">Manage Shared Rentals</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{packages}</span>
                                                <hr />
                                                <Link to="/admin/private_tours" className="action">View all Private Tours</Link>
                                                <br />
                                                <Link to="/admin/manage_private_tours" className="action">Manage Private Tours</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {(section == "" || section == "#users") && (
                            <>
                                {section === "" && sectionTitle("Users")}
                                <div className="widget col-6 col-md-4">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="text-center">
                                            <span className="count">
                                                {users}
                                            </span>
                                            <hr />
                                            <Link
                                                to="/admin/users_list"
                                                className="action"
                                            >
                                                View all Users
                                            </Link>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        {(section == "" || section == "#payments") && (
                            <Fragment>
                                {section === "" && sectionTitle("Payments")}
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">
                                                    {transactions}
                                                </span>
                                                <p className="small text-muted mb-2">Customer booking payments received</p>
                                                <hr />
                                                <Link
                                                    to="/admin/transactions"
                                                    className="action"
                                                >
                                                    Customer payments
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">
                                                    {service_transaction}
                                                </span>
                                                <p className="small text-muted mb-2">Vendor credits &amp; payout entries</p>
                                                <hr />
                                                <Link
                                                    to="/admin/service_transactions"
                                                    className="action"
                                                >
                                                    Vendor ledger
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}

                        {(section == "" || section == "#others") && section !== "" && (
                            <Fragment>
                                {section === "" && sectionTitle("Others")}
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">
                                                    {summary}
                                                </span>
                                                <hr />
                                                <Link
                                                    to="/admin/summaries"
                                                    className="action"
                                                >
                                                    Vendor payouts
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">
                                                    {faq}
                                                </span>
                                                <hr />
                                                <Link
                                                    to="/admin/faqs"
                                                    className="action"
                                                >
                                                    View all Faqs
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}

                        {(section == "" || section == "#packages") && (
                            <Fragment>
                                {section === "" && sectionTitle("Packages & more")}
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{inquiries}</span>
                                                <hr />
                                                <Link to="/admin/inquiries" className="action">View all Inquiries</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{packageBooking}</span>
                                                <hr />
                                                <Link to="/admin/package_booking" className="action">View all Private Tour Bookings</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* More — categories, partners, addons */}
                                {(section === "" || section === "#packages") && subsectionTitle("More")}
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{categories}</span>
                                                <hr />
                                                <Link to="/admin/categories" className="action">View all Categories</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="widget col-6 col-md-4">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="text-center">
                                                <span className="count">{addon}</span>
                                                <hr />
                                                <Link to="/admin/addons" className="action">View all Addons</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default Dashboard;









